<div *ngFor="let label of data.registrationLabels">{{label}}</div>